"use client";
import {
  TEntryType,
  usePublicationsFilter,
} from "@/contexts/publicationsSearch";
import { requestCmsData } from "@/utils/cmsClientQuery";
import { CheckSquare, RotateCw, Square } from "lucide-react";
import * as React from "react";
import { useForm, Controller } from "react-hook-form";

export const PublicationsFilters = () => {
  const { entryTypes, loading } = usePublicationsFilter();

  return (
    <div className="space-y-10 text-white">
      <div className="flex justify-between">
        <p className="border-b-2 border-b-white uppercase font-medium items-center">
          Filtrer par
        </p>
        {loading && <RotateCw size={18} className="animate-spin" />}
      </div>
      <PublicationsFiltersForm initialChoices={entryTypes as TEntryType[]} />
    </div>
  );
};

type FilterOptions = {
  choices: TEntryType[];
};

const PublicationsFiltersForm = ({
  initialChoices,
}: {
  initialChoices: TEntryType[];
}) => {
  const [entriesByTypeCount, setEntriesByTypeCount] = React.useState<any>(null);

  const { setEntryTypes } = usePublicationsFilter();
  // console.log("entryTypes from form", entryTypes);

  const { control, watch } = useForm<FilterOptions>({
    defaultValues: {
      choices: initialChoices ?? [],
      // choices: entryTypes ?? [],
    },
  });
  const selectedChoices = watch("choices");

  React.useEffect(() => {
    // Trigger an action each time the selected choices change
    handleSubmit(selectedChoices);
  }, [selectedChoices]);

  // React.useEffect(() => {
  //   console.log("entryTypes from form", entryTypes);
  //   reset({ ...getValues(), ...entryTypes });
  // }, [reset, getValues, entryTypes]);

  const handleSubmit = (choices: string[]) => {
    // Handle the submission logic here
    setEntryTypes(choices as TEntryType[]);
  };

  React.useEffect(() => {
    async function getEntriesCount(entryType: string) {
      const {
        postCollection: { total: articlesCount },
      } = await requestCmsData(`{
        postCollection(
          where:{
            contentfulMetadata:{
              tags: {
                id_contains_some: ["${entryType}"]
              } 
            }
          }
        ){
        total}
        }`);

      // console.log("articlesCount", articlesCount);
      setEntriesByTypeCount((prevState: any) => ({
        ...prevState,
        [entryType]: articlesCount,
      }));
    }
    getEntriesCount("article");
    getEntriesCount("publication");
    getEntriesCount("edition");
    getEntriesCount("parution");
    getEntriesCount("podcast");
  }, []);

  // console.log("articlesCount", articlesCount);

  const choices = [
    {
      label: `Articles et communiqués`,
      value: "article",
    },
    {
      label: `Publications réglementaires`,
      value: "publication",
    },
    {
      label: "Éditions",
      value: "edition",
    },
    {
      label: "Parutions",
      value: "parution",
    },
    {
      label: "Podcasts",
      value: "podcast",
    },
  ];

  return (
    <form>
      <Controller
        name="choices"
        control={control}
        render={({ field }) => (
          <div className="space-y-2">
            {choices.map((choice: any) => (
              <label
                key={choice.value}
                className="flex justify-start space-x-2 items-center cursor-pointer"
              >
                {!field.value.includes(choice.value) ? (
                  <Square size={18} />
                ) : (
                  <CheckSquare size={18} />
                )}
                <span>{choice.label}</span>
                <span className="text-xs text-white/70">
                  ({entriesByTypeCount && entriesByTypeCount[choice.value]})
                </span>
                <input
                  type="checkbox"
                  className="hidden"
                  value={choice.value}
                  checked={field.value.includes(choice.value)}
                  onChange={(e) => {
                    const newChoices = e.target.checked
                      ? [...field.value, e.target.value]
                      : field.value.filter(
                          (choice) => choice !== e.target.value
                        );
                    field.onChange(newChoices);
                  }}
                />
              </label>
            ))}
          </div>
        )}
      />
    </form>
  );
};
